import { render, staticRenderFns } from "./Advertisement.vue?vue&type=template&id=f4ed19a4&scoped=true&"
import script from "./Advertisement.vue?vue&type=script&lang=js&"
export * from "./Advertisement.vue?vue&type=script&lang=js&"
import style0 from "./Advertisement.vue?vue&type=style&index=0&id=f4ed19a4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4ed19a4",
  null
  
)

export default component.exports